export default __webpack_public_path__ + "static/Lato-Thin-1fd1d41f8c400da7af75c5c1821fd164.woff";